<template>
  <div v-loading="isLoading">
    <el-row class="panel-main">
      <el-col class="panel-left">
        <div :class="{'panel-title': true, 'panel-title-student': isStudent}">
          <el-button type="text" icon="el-icon-arrow-left" @click="onBack">{{ isAutonomous ? "返回账单列表": "返回"}}</el-button>
        </div>
        <div class="panel-content cs-fullHeight">
          <el-row v-if="!isStudent">
            <el-col :span="20">
              <h4>{{dataModel.phone}}</h4>
            </el-col>
          </el-row>
          <el-row v-if="!isStudent && wfModel && wfModel.IntroducerName">
            <el-col :span="20">
              <span>推荐人:</span>
              <span>{{wfModel.IntroducerName}}</span>
            </el-col>
          </el-row>
          <el-row v-if="!isStudent">
            <el-col :span="20">
              <span v-if="!dataModel.isAuId" class="cs-color-green">速成新生</span>
              <el-button class="edit-button" size="medium" type="text" @click="onShowMemberInfo">{{showMemberInfoBtnText}}
              </el-button>
            </el-col>
          </el-row>
          <el-row v-if="!isStudent" v-show="isMemberInfoVisible">
            <el-col :span="20">
              <member-info :options="optionsForComponents.memberInfo" :data-in="dataForComponents.memberInfo"></member-info>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <courseEnrollmentList :courseType="courseType" :isReadonly="true" :bonusPoint="bonusPoint" :dataIn="dataForComponents.courseEnrollmentList"
                :isCalculating="false" @contractAgreed="onContractAgreed"></courseEnrollmentList>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col class="panel-right">
        <div class="panel-title backgroud-gray-popup">
          <h4 v-if="isAutonomous">费用信息</h4>
          <h4 v-else>收费信息</h4>
          <!-- <el-button class="cs-btnBillDetail" size="small" type="primary" @click="onViewBillDetail">查看账单</el-button> -->
          <!-- <span v-if="isAutonomous">使用微信,支付宝或者信用卡付款，需额外收取3%手续费</span> -->
        </div>
        <div class="panel-content cs-fullHeight">
          <el-row>
            <el-col :span="24">
              <el-row v-if="dataModel.discountNameArr.length > 0">
                <el-col :span="12">
                  <span>学期优惠: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span class="dicountName" v-for="(item, index) in dataModel.discountNameArr" :key="index">{{item}}</span>
                </el-col>
              </el-row>
              <el-row v-if="dataModel.couponCode">
                <el-col :span="12">
                  <span>学生代理: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{dataModel.couponCode}}({{dataModel.couponDesc}})</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span>报名课数: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{dataModel.courseCount}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <hr>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span>课程原价: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{dataModel.courseTotalPrice | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!dataModel.courseTotalDecreaseAmount" class="cs-redLabel">
                <el-col :span="12">
                  <span>课程优惠: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * dataModel.courseTotalDecreaseAmount) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span>课程总价<span v-if="dataModel.hasRelatedWorkflow" class="cs-redLabel">(课程连报)</span>: </span>

                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{dataModel.courseTotalDiscountPrice | toCurrency}}</span>
                </el-col>
              </el-row>

              <el-row v-if="!!dataModel.workflowRelatedDicountAmount" class="cs-redLabel">
                <el-col :span="12">
                  <span>课程连报差价: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * dataModel.workflowRelatedDicountAmount) | toCurrency}}</span>
                </el-col>
              </el-row>

              <el-row v-if="courseType==1 && dataModel.supplementVideoTotalPrice > 0">
                <el-col :span="12">
                  <span>补看视频总价: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{dataModel.supplementVideoTotalPrice | toCurrency}}</span>
                </el-col>
              </el-row>

              <div v-if="!!dataModel.buyMemberCardPrice">
                <el-row>
                  <el-col :span="12">
                    <span>购买会员: </span>
                  </el-col>
                  <el-col :span="12" class="align-right">
                    <span>{{dataModel.buyMemberCardPrice | toCurrency}}</span>
                  </el-col>
                </el-row>
                <el-row v-if="status === 3 || status === 2">
                  <el-col :span="12">&nbsp;</el-col>
                  <el-col :span="12" class="align-right">
                    <a :href="memberCardConfig.ContractFileV1" target="_blank">黑卡会员须知</a>
                  </el-col>
                </el-row>
              </div>

              <el-row v-if="!!dataModel.bonusPointAmount" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用积分: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * dataModel.bonusPointAmount) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!dataModel.cashDecreasedAmount" class="cs-redLabel">
                <el-col :span="12">
                  <span>现金减: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * dataModel.cashDecreasedAmount) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!dataModel.couponDiscountDollar" class="cs-redLabel">
                <el-col :span="12">
                  <span>优惠劵: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * dataModel.couponDiscountDollar) | toCurrency}}</span>
                </el-col>
              </el-row>

              <el-row v-if="dataModel.totalTax > 0">
                <el-col :span="12">
                  <span>税前合计: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{courseTotalPriceBeforeTax | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="dataModel.isDoubleBonusPoint">
                <el-col :span="12">
                  <span class="cs-bold cs-color-darkred">双倍积分</span>
                </el-col>
              </el-row>
              <el-row v-if="dataModel.totalTax > 0">
                <el-col :span="12">
                  <span>税费(HST:{{ wfModel.TaxRate | toPercent}}): </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{dataModel.totalTax | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="isAutonomous && paidServiceCharge > 0">
                <el-col :span="12">
                  <span>手续费: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{paidServiceCharge | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="dataModel.totalTax > 0">
                <el-col :span="12">
                  <span>总计: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{totalAmount | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!dataModel.advanceEnrollmentPrice" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用占位: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * (dataModel.advanceEnrollmentPrice + dataModel.advanceEnrollmentPriceTax)) | toCurrency}}</span>
                </el-col>
              </el-row>
              <!-- <el-row v-if="!!dataModel.balanceCost" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * (dataModel.balanceCost + dataModel.balanceCostTax)) | toCurrency}}</span>
                </el-col>
              </el-row> -->
              <el-row v-if="!!newBalanceCostTotal" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用新余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * newBalanceCostTotal) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!giftBalanceCostTotal" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用赠送余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * giftBalanceCostTotal) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!oldBalanceCostTotal" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用旧余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * oldBalanceCostTotal) | toCurrency}}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <hr>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <accountInfo :options="optionsForComponents.accountInfo" :data="dataForComponents.accountInfo"></accountInfo>
            </el-col>
          </el-row>
          <el-row v-if="!!dataModel.refundRelatedDicountAmountTotal" class="cs-redLabel">
            <el-col :span="10">
              <span>课程连报退款差价: </span>
            </el-col>
            <el-col :span="10" class="align-right">
              <span>{{(-1 * dataModel.refundRelatedDicountAmountTotal) | toCurrency}}</span>
            </el-col>
          </el-row>

          <el-row v-if="!!accountModel && accountModel.ChangedAmount != 0" class="cs-redLabel">
            <el-col :span="10">
              <span>换课差价: </span>
            </el-col>
            <el-col :span="10" class="align-right">
              <span>{{(accountModel.ChangedAmount + accountModel.ChangedAmountTax) | toCurrency}}</span>
            </el-col>
          </el-row>

          <el-row v-if="!!dataModel.refundBalanceTotal" class="cs-redLabel">
            <el-col :span="10">
              <span>已退余额: </span>
            </el-col>
            <el-col :span="10" class="align-right">
              <span>{{(-1 * dataModel.refundBalanceTotal) | toCurrency}}</span>
            </el-col>
          </el-row>
          <el-row v-if="!!dataModel.refundBonusPointAmountTotal" class="cs-redLabel">
            <el-col :span="10">
              <span>已退积分: </span>
            </el-col>
            <el-col :span="10" class="align-right">
              <span>{{(-1 * dataModel.refundBonusPointAmountTotal) | toCurrency}}</span>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col>
              <hr>
            </el-col>
          </el-row> -->
          <el-row class="section-title">
            <el-col :span="6">
              <span>支付详情: </span>
            </el-col>
            <el-col :span="18" class="cs-ef-status">
              <el-button v-if="isCheckPaymentVisible" :loading="isPaymentChecking" size="small" type="primary" @click="onCheckPaymentClick">检查修复</el-button>
              <el-dropdown class="margin-left-20px" v-if="isStatusListVisible" @command="handleStatusChange">
                <span :class="getStatusClass(status)">
                  {{getStatusText(status)}}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in statusList" :key="item.key" :command="item.key" :class="getStatusClass(item.key)">{{item.value}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
          <el-row v-if="isCheckPaymentVisible && !!qrCodeImage">
            <div>支付方式：<i class="icon"><img :src="paymentTypeIcon" /></i></div>
            <img :src="qrCodeImage" />
          </el-row>
          <el-row v-if="isStudent && isAutonomous && status == 1">
            <el-col>
              <el-button size="medium" type="primary" @click="onPaymentClick">支付账单
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <payment-list-view ref="payment-list-view" :data-list="dataModel.accountPayments" :options="optionsForComponents.paymentListView"
                @item-click="onPaymentListViewItemClick" @item-remove="onPaymentListViewItemRemove"></payment-list-view>
            </el-col>
          </el-row>
          <el-row v-if="!!dataForComponents.accountInfo.excessAmount">
            <el-col :span="14">
              <span>超出金额: </span>
            </el-col>
            <el-col :span="10" class="align-right">
              <span>{{dataForComponents.accountInfo.excessAmount | toCurrency}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <span>待付款(除手续费): </span>
            </el-col>
            <el-col :span="10" class="align-right">
              <span>{{dataForComponents.accountInfo.debt | toCurrency}}</span>
            </el-col>
          </el-row>
          <el-row v-if="!isAutonomous">
            <el-col>
              <hr>
            </el-col>
          </el-row>
          <!-- <el-row v-if="!isAutonomous">
            <el-col>
              <span>付款备注: </span>
            </el-col>
          </el-row>
          <el-row v-if="!isAutonomous">
            <el-col :span="20">
              <el-input type="textarea" :rows="4" resize="none" v-model="paymentComments" :disabled="true"></el-input>
            </el-col>
          </el-row> -->
          <el-row v-if="!isAutonomous">
            <el-col>
              <span>账目备注: </span>
              <el-button v-if="optionsForComponents.paymentListView.enableEdit" class="edit-button" size="medium margin-left-10" type="text"
                @click="onEidtAccountCommentClick()">编辑备注</el-button>
            </el-col>
          </el-row>
          <el-row v-if="!isAutonomous">
            <el-col :span="20">
              <el-input type="textarea" :rows="4" resize="none" v-model="accountModel.Comment" :disabled="true"></el-input>
            </el-col>
          </el-row>
          <el-row v-if="!isAutonomous">
            <el-col>
              <hr>
            </el-col>
          </el-row>
          <el-row v-if="!isAutonomous">
            <el-col>
              <workflow-image-list :data="dataForComponents.workflowImageList" :readonly="false"></workflow-image-list>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="合同签署" :center="true" :close-on-click-modal="false" :visible.sync="contractDialogVisible" width="900px" top="8vh">
      <div class="contract-viewer-container">
        <contractViewer :workflowId="wfModel ? wfModel.Id : 0" v-on:contractSigned="onContractSigned"></contractViewer>
      </div>
    </el-dialog>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="paymentEditorVisible" top="3vh">
      <payment-editor ref="payment-editor" :account-id="accountId" :data="dataForComponents.paymentEditor" :options="optionsForComponents.paymentEditor"
        :conditions="conditionsForComponents.paymentEditor" @closeDialog="onPaymentEditorClose" @callback="onPaymentEditorCallback"></payment-editor>
    </el-dialog>
    <paymentBillEditor key="paymentBillEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :data="dataForComponents.paymentBillEditor"
      @completed="onPaymentBillEditorCompleted" />
    <qrCodeViewer key="qrCodeViewer" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :data="dataForComponents.qrCodeViewer"
      @success="onQRCodeViewerSuccess" />
    <stripeHandler key="stripeHandler" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :data="dataForComponents.stripeHandler" />

    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="paymentCommentEditorVisible" top="5vh">
      <paymentCommentEditor :dataIn="dataForComponents.paymentCommentEditor" @success="onPaymentCommentEditorSuccess" />
    </el-dialog>

    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="accountCommentEditorVisible" top="5vh">
      <accountCommentEditor :dataIn="dataForComponents.accountCommentEditor" @success="onAccountCommentEditorSuccess" />
    </el-dialog>
    <el-dialog title="账单详情" :center="true" :close-on-click-modal="false" :visible.sync="billDetailDialogVisible" width="900px" top="5vh">
      <billDetail :dataIn="dataForComponents.billDetail" :studentPhone="dataModel.phone" :billDate="billDate"></billDetail>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.panel-main {
  display: flex;
  hr {
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
  }
}

.panel-left {
  flex: 2;
}

.panel-right {
  flex: 1;
  border-left: 1px solid rgb(227, 227, 227);

  .panel-content {
    padding-top: 0.8rem;
  }
}

.panel-title {
  padding: 20px 40px 20px 40px;
  min-height: 70px;
  display: flex;

  h4 {
    margin-bottom: 0;
  }

  &.panel-title-student {
    padding-bottom: 0;
  }

  .cs-btnBillDetail{
    margin-left: auto;
  }
}

.dicountName {
  display: block;
}
.cs-ef-status {
  text-align: right;
}

.icon {
  padding: 0;
  width: 32px;
  height: 32px;

  img {
    vertical-align: middle;
    text-align: center;
    width: 32px;
    height: 32px;
  }
}
</style>

<script>
import { getPaymentImgList } from "@/config/mUtils.js";

import navigator from "../../components/navigator";
import memberInfo from "../common/memberInfo_new";
import courseEnrollmentList from "../addCollectFees/courseEnrollmentFee/courseEnrollmentList";
import billDetail from "../addCollectFees/courseEnrollmentFee/billDetail";
import accountInfo from "../../components/finance/accountInfo";
import paymentListView from "../../components/common/paymentListView";
import paymentEditor from "../../components/common/paymentEditor";
import workflowImageList from "@/components/common/workflowImageList";
import {
  getCourseTypeText,
  toDecimal,
  getWorkflowStatusClass,
  getPaymentTypeDescription,
  getAutonomousWorkflowStatusList,
  getDiscountDesc,
} from "../../config/mUtils";
import { getMemberCardConfig } from "@/service/common.service";
import { getStudentMemberInfo } from "../../service/student.service";
import {
  getFormulaListByType,
  saveAccount,
  getAccount,
  createCreditCardPayment,
} from "../../service/finance.service";
import {
  createWorkflowModel,
  getDiscountArrayFromWorkflow,
  getWorkflowDataByAccountId,
  saveWorkflowStatus,
  refreshEFWorkflowStatus,
} from "../../service/enrollmentFee.service";
import { checkWorkflowHasUnsignedContracts } from "../../service/contract.service";
import contractViewer from "../../components/contract/contractViewer.vue";
let moment = require("moment");

export default {
  name: "cefAccountProfile",
  props: {
    data: {
      isAutonomous: Boolean,
      accountId: Number,
      account: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      isMemberInfoVisible: false,
      showMemberInfoBtnText: "查看完整信息",
      accountId: 0,
      dataChanged: false,
      memberCardConfig: {
        ContractFile: null,
      },
      formulaList: [],
      wfModel: null,
      studentModel: null,
      accountModel: {},
      bonusPoint: 0,
      dataModel: {
        phone: null,
        studentId: 0,
        isAuId: false,
        discountNameArr: [],
        courseCount: 0,
        buyMemberCardPrice: 0,
        courseTotalDiscountPrice: 0,
        supplementVideoTotalPrice: 0,
        totalTax: 0,
        advanceEnrollmentPrice: 0,
        advanceEnrollmentPriceTax: 0,
        balanceCost: 0,
        balanceCostTax: 0,
        giftBalanceCost: 0,
        oldBalanceCost: 0,
        newBalanceCost: 0,
        giftBalanceCostTax: 0,
        oldBalanceCostTax: 0,
        newBalanceCostTax: 0,
        bonusPointAmount: 0,
        cashDecreasedAmount: 0,
        couponDiscountDollar: 0,
        courseTotalDecreaseAmount: 0,
        workflowRelatedDicountAmount: 0,
        refundBalanceTotal: 0,
        refundBonusPointTotal: 0,
        refundBonusPointAmountTotal: 0,
        hasRelatedWorkflow: false,
        refundRelatedDicountAmountTotal: 0,
        accountPayments: [],
        couponCode: "",
        couponDesc: "",
      },
      optionsForComponents: {
        memberInfo: {
          showTitle: false,
          showPhone: false,
          enableEdit: false,
          enableBuymember: false,
          showIsNew: false,
          enableRegister: false,
        },
        accountInfo: {
          displayType: "simple2",
          isAutonomousModel: false,
        },
        paymentListView: {
          displayType: "simple",
          enableEdit: true,
          enableRemove: false,
          isAutonomous: false,
          isAutonomousPaymentWorkflow: false,
        },
        paymentEditor: {
          showTitle: true,
          allowPaidCount: 0,
        },
      },
      dataForComponents: {
        memberInfo: {
          memberModel: null,
        },
        courseEnrollmentList: {
          termId: 0,
          comment: "",
          enrollmentAvailableCount: 0,
          trainingEnrollmentAvailableCount: 0,
          courseList: [],
        },
        accountInfo: {
          amount: 0,
          amountTax: 0,
          paidAmount: 0,
          paidAmountTax: 0,
          excessAmount: 0,
          debt: 0,
          balanceInStore: 0,
        },
        paymentEditor: {
          index: -1,
          item: null,
          hasTax: false,
          taxRate: 0,
        },
        workflowImageList: {
          workflowId: 0,
        },
        paymentBillEditor: {
          currency: 2,
          paymentAmount: 0,
        },
        qrCodeViewer: {
          workflowId: 0,
          paymentAmount: 0,
          tipAmount: 0,
          paymentType: null,
          description: null,
        },
        stripeHandler: {
          workflowId: 0,
          autonomousPaymentRecordId: null,
          paymentAmount: 0,
          tipAmount: 0,
          description: null,
        },
        paymentCommentEditor: {
          accountPaymentId: 0,
          comment: "",
        },
        accountCommentEditor: {
          accountId: 0,
          comment: "",
        },
        billDetail: {
          discountNames: "",
          courseList: [],
          courseOriginalPrice: 0,
          courseTotalDiscountPrice: 0,
          courseTotalDecreaseAmount: 0,
          workflowRelatedDicountAmount: 0,
          balance: 0,
          bonusPointAmount: 0,
          enrollmentCountAmount: 0,
          accountDiscountAmount: 0,
          taxModel: {
            hasTax: false,
            taxRate: 0.13,
            courseTotalTax: 0
          },
          accountAmount: 0,
        },
      },
      conditionsForComponents: {
        paymentEditor: {
          paidCount: 0,
          paymentAmount: 0,
        },
      },
      paymentEditorVisible: false,
      editIndex: -1,
      editPayment: null,
      courseType: 1,

      imageUploaderVisible: false,
      imageShowerVisible: false,

      isAutonomous: false,
      isStudent: false,
      isCompleted: false,
      status: 0,
      allStatusList: [],
      statusList: [],
      isStatusListVisible: false,
      isCheckPaymentVisible: false,
      isPaymentChecking: false,
      qrCodeImage: null,
      contractDialogVisible: false,
      workflowHasUnsignedContracts: false,
      paymentCommentEditorVisible: false,
      accountCommentEditorVisible: false,
      billDetailDialogVisible: false,
    };
  },
  components: {
    navigator,
    memberInfo,
    courseEnrollmentList,
    billDetail,
    accountInfo,
    paymentListView,
    paymentEditor,
    workflowImageList,
    contractViewer,
    paymentBillEditor: () => import("@/components/payApi/paymentBillEditor"),
    qrCodeViewer: () => import("@/components/payApi/qrCodeViewer"),
    stripeHandler: () => import("@/components/stripe/stripeHandler"),
    paymentCommentEditor: () =>
      import("@/components/finance/paymentCommentEditor"),
    accountCommentEditor: () =>
      import("@/components/finance/accountCommentEditor"),
  },
  computed: {
    paidAmount: function () {
      let result = this.__getPaidAmount();

      return result;
    },
    paidAmountTax: function () {
      let result = this.__getPaidAmountTax();

      return result;
    },
    paidServiceCharge: function () {
      let result = this.__getPaidServiceCharge();

      return result;
    },
    totalAmount: function () {
      let value = this.dataModel.totalTax + this.courseTotalPriceBeforeTax;
      if (this.isAutonomous) {
        value += this.paidServiceCharge;
      }
      return value;
    },
    excessAmount: function () {
      if (
        !this.accountModel ||
        this.paidAmount + this.paidAmountTax <=
          this.accountModel.Amount + this.accountModel.AmountTax
      )
        return 0;

      return (
        this.paidAmount +
        this.paidAmountTax -
        this.accountModel.Amount -
        this.accountModel.AmountTax +
        this.accountModel.ChangedAmount +
        this.accountModel.ChangedAmountTax
      );
    },
    paymentComments: function () {
      let comments = "";
      // if (!!this.wfModel && !!this.wfModel.Comment) {
      //   comments = this.wfModel.Comment;
      // }
      if (
        !this.accountModel ||
        !this.accountModel.AccountPayments ||
        this.accountModel.AccountPayments.length == 0
      )
        return comments;

      let result = "";
      for (let i = 0; i < this.accountModel.AccountPayments.length; i++) {
        let payment = this.accountModel.AccountPayments[i];
        if (!payment.Enable || !payment.Comment) continue;
        result += `${payment.Comment}\r\n`;
      }

      if (!!comments) comments += "\r\n";
      if (!!result) {
        comments += result;
      }

      return comments;
    },
    courseTotalPriceBeforeTax: function () {
      return (
        this.dataModel.courseTotalDiscountPrice -
        this.dataModel.bonusPointAmount -
        this.dataModel.cashDecreasedAmount -
        this.dataModel.couponDiscountDollar
      );
    },
    paymentTypeIcon() {
      if (!this.wfModel) return null;

      let key = this.GLOBAL.enumPaymentType.getAttrValue(
        this.wfModel.PaymentType,
        "key"
      );
      if (!key) return null;

      return this.paymentImgList[key];
    },
    balanceCostTaxTotal() {
      return (
        this.dataModel.newBalanceCostTax +
        this.dataModel.giftBalanceCostTax +
        this.dataModel.oldBalanceCostTax
      );
    },
    giftBalanceCostTotal() {
      return this.dataModel.giftBalanceCost + this.dataModel.giftBalanceCostTax;
    },
    oldBalanceCostTotal() {
      return this.dataModel.oldBalanceCost + this.dataModel.oldBalanceCostTax;
    },
    newBalanceCostTotal() {
      return this.dataModel.newBalanceCost + this.dataModel.newBalanceCostTax;
    },
    billDate() {
      if (!!this.accountModel && !!this.accountModel.CreateDate) {
        return moment(this.accountModel.CreateDate).format("YYYY-MM-DD");
      }
      const now = new Date();
      return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    },
  },
  beforeCreate() {
    this.paymentImgList = getPaymentImgList();
  },
  created() {
    this.allStatusList = getAutonomousWorkflowStatusList();
    this.isStudent = this.USERMANAGER.isStudent;
    this.init();
  },
  methods: {
    async loadMemberCardConfigFromServer() {
      try {
        let result = await getMemberCardConfig();
        if (!!result && result.success) {
          this.memberCardConfig = result.data;
        }
      } catch (error) {}
    },
    async loadFormulaListFromServer() {
      let result = await getFormulaListByType(
        this.GLOBAL.formulaType.discount,
        this.GLOBAL.accountType.signClass,
        this.accountId
      );
      if (!!result && result.success) {
        this.formulaList = result.data;
      } else {
        this.formulaList = [];
      }
    },
    async loadWorkflowDataFromServer() {
      this.isCheckPaymentVisible = false;
      this.isPaymentChecking = false;
      if (!this.accountId) {
        this.wfModel = null;
        return;
      }

      let result = await getWorkflowDataByAccountId(this.accountId);
      if (!!result && result.success) {
        this.wfModel = result.data;
        this.status = this.wfModel.Status;
        this.isStatusListVisible = false;
        if (this.isAutonomous && !this.USERMANAGER.isStudent) {
          if (this.status != 3) {
            this.isCheckPaymentVisible = true;
            this.qrCodeImage = this.wfModel.QRCodeImage;
          }
          if (
            this.USERMANAGER.isAdmin ||
            this.status == 2 ||
            this.status == 4
          ) {
            this.loadStatusList();
            this.isStatusListVisible = true;
          }
        }
      } else {
        this.wfModel = null;
        this.status = 0;
        this.isStatusListVisible = false;
      }
    },
    loadStatusList() {
      this.statusList = this.allStatusList.filter(
        (i) => i.key != 1 && i.key != this.status
      );
    },
    async loadStudentMemberInfoFromServer(
      studentId = this.dataModel.studentId
    ) {
      if (!studentId) {
        this.studentModel = null;
        this.bonusPoint = 0;
        return;
      }

      let result = await getStudentMemberInfo(studentId);
      if (!!result && result.success) {
        this.studentModel = result.data;
        this.bonusPoint = this.studentModel.BonusPoint;
      } else {
        this.studentModel = null;
        this.bonusPoint = 0;
      }
    },
    loadAccountDataFromProps(account) {
      if (!!account) {
        this.accountId = account.Id;
        this.accountModel = account;
      } else {
        this.accountId = 0;
        this.accountModel = null;
      }
    },
    async saveAccountDataToServer(saveData) {
      if (!saveData) return false;

      let result = await saveAccount(saveData);

      return !!result && result.success;
    },
    async refreshEFWorkflowStatusFromServer() {
      try {
        let workflowId = !!this.wfModel ? this.wfModel.Id : 0;
        let result = await refreshEFWorkflowStatus(workflowId);

        return !!result && result.success;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async init() {
      this.isLoading = true;

      await this.loadMemberCardConfigFromServer();

      if (!!this.data) {
        let accountData = null;
        if (this.data.account) {
          accountData = this.data.account;
        } else if (this.data.accountId) {
          let result = await getAccount(this.data.accountId);
          accountData = result.data;
        }
        this.isAutonomous = !!this.data.isAutonomous;

        if (!!accountData) {
          this.loadAccountDataFromProps(accountData);
          await this.loadFormulaListFromServer();
          await this.reloadAllDataModel();
        }
      }

      if (this.isAutonomous) {
        this.isCompleted = this.status != 1;
        this.optionsForComponents.paymentListView = {
          displayType: "simple",
          enableEdit: this.isStudent && this.status == 4,
          enableRemove: false,
          isAutonomous: true,
          isAutonomousPaymentWorkflow: false,
        };
        this.optionsForComponents.accountInfo.isAutonomousModel = true;
      } else {
        if (this.wfModel) {
          this.optionsForComponents.paymentListView.isAutonomousPaymentWorkflow =
            this.wfModel.IsAutonomousPayment;
        }
      }

      this.isLoading = false;
    },
    async reloadAllDataModel() {
      this.isMemberInfoVisible = false;
      this.showMemberInfoBtnText = "查看完整信息";

      await this.loadWorkflowDataFromServer();
      let studentId = !!this.wfModel ? this.wfModel.StudentId : 0;
      await this.loadWorkflowHasUnsignedContracts();
      await this.loadStudentMemberInfoFromServer(studentId);
      await this.reloadDataModel();
      this.reloadDataForMemberInfo();
      this.reloadDataForCourseEnrollmentList();
      this.reloadDataForAccountInfo();
      this.reloadDataForWorkflowImageList();
    },
    async loadWorkflowHasUnsignedContracts() {
      if (this.wfModel) {
        let result = await checkWorkflowHasUnsignedContracts(this.wfModel.Id);
        if (result && result.success) {
          this.workflowHasUnsignedContracts = result.data;
        }
      }
    },
    async reloadDataModel() {
      if (!!this.wfModel) {
        let discounts = getDiscountArrayFromWorkflow(this.wfModel);
        let discountNameArr = [];
        for (let i = 0; i < discounts.length; i++) {
          let formulaId = discounts[i];
          let formulaModel = this.__findFormulaModel(formulaId);
          if (!!formulaModel) discountNameArr.push(formulaModel.LabelName);
        }

        this.dataModel.phone = this.wfModel.Phone;
        this.dataModel.studentId = this.wfModel.StudentId;
        this.dataModel.discountNameArr = discountNameArr;
        this.dataModel.courseCount = this.wfModel.WorkflowCourses.length;
        this.dataModel.buyMemberCardPrice = this.wfModel.BuyMemberCardPrice;
        this.dataModel.courseTotalPrice = this.__getCourseTotalPrice();
        this.dataModel.courseTotalDiscountPrice =
          this.__getCourseTotalDiscountPrice();
        this.dataModel.supplementVideoTotalPrice =
          this.__getSupplementVideoTotalPrice();
        this.dataModel.totalTax = this.wfModel.CourseTotalTax;
        this.dataModel.advanceEnrollmentPrice =
          this.wfModel.AdvanceEnrollmentPrice;
        this.dataModel.advanceEnrollmentPriceTax =
          this.wfModel.AdvanceEnrollmentPriceTax;
        this.dataModel.balanceCost = this.wfModel.BalanceCost;
        this.dataModel.balanceCostTax = this.wfModel.BalanceCostTax;
        this.dataModel.giftBalanceCost = this.wfModel.GiftBalanceCost;
        this.dataModel.oldBalanceCost = this.wfModel.OldBalanceCost;
        this.dataModel.newBalanceCost = this.wfModel.NewBalanceCost;
        this.dataModel.giftBalanceCostTax = this.wfModel.GiftBalanceCostTax;
        this.dataModel.oldBalanceCostTax = this.wfModel.OldBalanceCostTax;
        this.dataModel.newBalanceCostTax = this.wfModel.NewBalanceCostTax;
        this.dataModel.bonusPointAmount = this.wfModel.BonusPointAmount;
        this.dataModel.cashDecreasedAmount = this.wfModel.CashDecreasedAmount;
        this.dataModel.couponDiscountDollar = this.wfModel.CouponDiscountDollar;
        this.dataModel.courseTotalDecreaseAmount =
          this.__getCourseTotalDecreaseAmount();
        this.dataModel.workflowRelatedDicountAmount =
          this.wfModel.WorkflowRelatedDicountAmount;
        this.dataModel.refundBalanceTotal = this.__getRefundBalanceTotal();
        this.dataModel.refundBonusPointTotal =
          this.__getRefundBonusPointTotal();
        this.dataModel.refundBonusPointAmountTotal =
          this.__getRefundBonusPointAmountTotal();
        this.dataModel.hasRelatedWorkflow =
          this.wfModel.RelatedWorkflowIdList.length > 0;
        this.dataModel.refundRelatedDicountAmountTotal =
          this.__getRefundRelatedDicountAmountTotal();

        this.dataModel.couponCode = this.wfModel.CouponCode;
        this.dataModel.couponDesc = getDiscountDesc(
          this.wfModel.CouponDiscountValue
        );
        this.dataModel.isDoubleBonusPoint = this.wfModel.IsDoubleBonusPoint;
      } else {
        this.dataModel.phone = null;
        this.dataModel.studentId = 0;
        this.dataModel.discountNameArr = [];
        this.dataModel.courseCount = 0;
        this.dataModel.buyMemberCardPrice = 0;
        this.dataModel.courseTotalPrice = 0;
        this.dataModel.courseTotalDiscountPrice = 0;
        this.dataModel.totalTax = 0;
        this.dataModel.advanceEnrollmentPrice = 0;
        this.dataModel.advanceEnrollmentPriceTax = 0;
        this.dataModel.balanceCost = 0;
        this.dataModel.balanceCostTax = 0;
        this.dataModel.giftBalanceCost = 0;
        this.dataModel.oldBalanceCost = 0;
        this.dataModel.newBalanceCost = 0;
        this.dataModel.giftBalanceCostTax = 0;
        this.dataModel.oldBalanceCostTax = 0;
        this.dataModel.newBalanceCostTax = 0;
        this.dataModel.bonusPointAmount = 0;
        this.dataModel.cashDecreasedAmount = 0;
        this.dataModel.couponDiscountDollar = 0;
        this.dataModel.courseTotalDecreaseAmount = 0;
        (this.dataModel.workflowRelatedDicountAmount = 0),
          (this.dataModel.refundBalanceTotal = 0);
        this.dataModel.refundBonusPointTotal = 0;
        this.dataModel.refundBonusPointAmountTotal = 0;
        this.dataModel.hasRelatedWorkflow = false;
        this.dataModel.refundRelatedDicountAmountTotal = 0;
        this.dataModel.couponCode = "";
        this.dataModel.couponDesc = "";
      }

      if (!!this.studentModel) {
        this.dataModel.isAuId = this.studentModel.IsAuId;
      } else {
        this.dataModel.isAuId = false;
      }

      if (!!this.accountModel) {
        this.dataModel.accountPayments = $.extend(
          true,
          [],
          this.accountModel.AccountPayments
        );
      } else {
        this.dataModel.accountPayments = [];
      }
    },
    reloadDataForMemberInfo() {
      let newData = {
        memberModel: null,
      };

      newData.memberModel = this.studentModel;

      this.dataForComponents.memberInfo = newData;
    },
    reloadDataForCourseEnrollmentList() {
      let newData = {
        termId: 0,
        comment: "",
        enrollmentAvailableCount: 0,
        trainingEnrollmentAvailableCount: 0,
        courseList: [],
      };

      if (!!this.wfModel) {
        let enrollmentCount = 0;
        let trainingEnrollmentCount = 0;
        if (!!this.studentModel) {
          enrollmentCount =
            this.studentModel.AdvanceEnrollmentCount -
            this.studentModel.AdvanceEnrollmentCountUsed;
          trainingEnrollmentCount =
            this.studentModel.TrainingAdvanceEnrollmentCount -
            this.studentModel.TrainingAdvanceEnrollmentCountUsed;
        }

        let list = [];
        if (
          !!this.wfModel.WorkflowCourses &&
          this.wfModel.WorkflowCourses.length > 0
        ) {
          this.courseType = this.wfModel.WorkflowCourses[0].CourseType;
          this.wfModel.WorkflowCourses.forEach((element) => {
            let itemData = {
              modelData: {
                id: element.Id,
                isAdvanceEnrollmentPrice: element.IsAdvanceEnrollmentPrice,
                isInternalPrice: element.IsInternalPrice,
                isOriginalPrice: element.IsOriginalPrice,
                isFreeTrial: element.IsFreeTrial,
                startWeek: element.StartWeek,
                categoryId: element.CourseCategoryId,
                categoryOptionId: element.CourseCategoryOptionId,
                vipCoursePriceId: element.VipCoursePriceId,
                courseCount: element.CourseCount,
                courseMinutes: element.CourseMinutes,
                supplementVideoType: element.SupplementVideoType,
                supplementVideoCount: element.SupplementVideoCount,
                contractId: element.ContractId,
                hasContractAgreed: element.HasContractAgreed,
                weChatGroupType: element.WeChatGroupType,
                yearCourseType: element.YearCourseType,
                comment: element.Comment,
                courseAlias: element.CourseAlias,
                reviewCourseStart: element.ReviewCourseStartValue,
                reviewCourseEnd: element.ReviewCourseEndValue,
              },
              priceData: {
                price: element.Price,
                weekPrice: element.WeekPrice,
                discountPrice: element.DiscountPrice,
                subtotal:
                  element.PaymentDiscountPrice -
                  element.BonusPointAmount -
                  element.CashDecreasedAmount -
                  element.CouponDiscountDollar,
                supplementVideoPrice: element.SupplementVideoPrice,
                changeCourseDifferentPrice: element.ChangeCourseDifferentPrice,
                changeCourseRefundPrice: element.ChangeCourseRefundPrice,
                changeCourseRefundBalance: element.ChangeCourseRefundBalance,
                bonusPointCost: element.BonusPointCost,
                bonusPointAmount: element.BonusPointAmount,
                cashDecreasedAmount: element.CashDecreasedAmount,
                couponCode: element.CouponCode,
                couponDiscountDollar: element.CouponDiscountDollar,
              },
              courseId: element.CourseId,
              courseName: element.CourseName,
              courseType: element.CourseType,
              courseTypeText: getCourseTypeText(element.CourseType),
              universityGroup: !!this.studentModel
                ? this.studentModel.UniversityGroupNumber
                : 0,
              universityGroupText: !!this.studentModel
                ? this.studentModel.UniversityGroupText
                : "",
              termId: this.wfModel.TermId,
              termText: this.wfModel.TermText,
              isRefund: element.IsRefund,
              changeFromCourseName: element.ChangeFromCourseName,
              categoryId: this.wfModel.CategoryId,
              categoryText: this.wfModel.CategoryText,
              campusId: element.CampusId,
              campusText: element.CampusText,
              isHourPrice: false,
              isYearCourse: element.IsYearCourse,
              yearCourseType: element.YearCourseType,
            };

            if (element.CourseType == 2) {
              itemData.isHourPrice = element.IsHourPrice;
            }

            list.push(itemData);
          });
        }

        newData.termId = this.wfModel.TermId;
        newData.comment = this.wfModel.Comment;
        newData.enrollmentAvailableCount = enrollmentCount;
        newData.trainingEnrollmentAvailableCount = trainingEnrollmentCount;
        newData.courseList = list;
      }

      this.dataForComponents.courseEnrollmentList = newData;
    },
    reloadDataForAccountInfo() {
      let newData = {
        amount: 0,
        amountTax: 0,
        paidAmount: 0,
        paidAmountTax: 0,
        excessAmount: 0,
        debt: 0,
        balanceInStore: 0,
        isAutonomous: this.isAutonomous,
      };

      if (!!this.accountModel) {
        newData.amount = this.accountModel.Amount;
        newData.amountTax = this.accountModel.AmountTax;
        newData.paidAmount = this.paidAmount;
        newData.paidAmountTax = this.paidAmountTax;
        newData.paidServiceCharge = this.paidServiceCharge;
        newData.excessAmount = this.excessAmount;
        newData.debt = this.accountModel.Debt;
        if (this.wfModel) {
          newData.balanceInStore = this.wfModel.BalanceInStore;
        }
      }

      this.dataForComponents.accountInfo = newData;
    },
    reloadDataForPaymentEditor() {
      let newData = {
        index: -1,
        item: null,
        hasTax: this.wfModel.HasTax,
        taxRate: this.wfModel.TaxRate,
      };

      newData.index = this.editIndex;
      newData.item = this.editPayment;

      this.dataForComponents.paymentEditor = newData;
    },
    reloadDataForWorkflowImageList() {
      let newData = {
        workflowId: 0,
      };

      newData.workflowId = !!this.wfModel ? this.wfModel.Id : 0;

      this.dataForComponents.workflowImageList = newData;
    },
    async onBack() {
      let isReload = this.dataChanged;
      this.$emit("close", isReload);
      this.dataChanged = false;
    },
    onShowMemberInfo() {
      this.isMemberInfoVisible = !this.isMemberInfoVisible;
      this.showMemberInfoBtnText = this.isMemberInfoVisible
        ? "隐藏完整信息"
        : "查看完整信息";
    },
    onPaymentListViewItemClick(dataOut) {
      if (dataOut.isEditComment) {
        this.openPaymentCommentEditor(dataOut.item);
      } else if (dataOut.isAutonomous) {
        this.reloadDataForPaymentBillEditor(dataOut.item);
        this.openPaymentBillEditor();
      } else {
        this.editIndex = dataOut.index;
        this.editPayment = dataOut.item;
        this.reloadDataForPaymentEditor();

        this.paymentEditorVisible = true;
      }
    },
    async onPaymentListViewItemRemove(dataOut) {
      let confirmResult = false;
      await this.$confirm("是否删除该项支付?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          confirmResult = true;
        })
        .catch(() => {});
      if (!confirmResult) return;

      let saveData = this.__getSaveModel();
      let payment =
        dataOut.index >= 0 ? saveData.AccountPayments[dataOut.index] : null;
      if (!payment) return;

      payment.Enable = false;

      let result = await this.saveAccountDataToServer(saveData);
      this.$message({
        message: `删除${result ? "成功" : "失败"}`,
        type: result ? "success" : "error",
      });
      if (!result) return;

      this.loadAccountDataFromProps(saveData);
      await this.reloadDataModel();
      this.reloadDataForAccountInfo();
      this.dataChanged = true;
    },
    onPaymentEditorClose() {
      this.paymentEditorVisible = false;
      this.editIndex = -1;
      this.editPayment = null;
      this.reloadDataForPaymentEditor();
    },
    async onPaymentEditorCallback(dataOut) {
      let saveData = this.__getSaveModel();
      let payment =
        dataOut.index >= 0 ? saveData.AccountPayments[dataOut.index] : null;
      if (!payment) return;

      payment.PaymentTypeId = dataOut.data.PaymentTypeId;
      payment.ServiceCharge = dataOut.data.ServiceCharge;
      payment.Amount = dataOut.data.Amount;
      payment.Tax = dataOut.data.Tax;
      payment.Comment = dataOut.data.Comment;

      let result = await this.saveAccountDataToServer(saveData);
      this.$message({
        message: `保存${result ? "成功" : "失败"}`,
        type: result ? "success" : "error",
      });
      if (!result) return;

      this.loadAccountDataFromProps(saveData);
      await this.reloadDataModel();
      this.reloadDataForAccountInfo();
      this.dataChanged = true;
    },
    __findFormulaModel(formulaId) {
      if (!this.formulaList || this.formulaList.length == 0) return null;

      let formulaModel = null;

      for (let i = 0; i < this.formulaList.length; i++) {
        let item = this.formulaList[i];
        if (item.Id == formulaId) {
          formulaModel = item;
          break;
        }
      }

      return formulaModel;
    },
    __getCourseTotalPrice(workflowData = this.wfModel) {
      if (
        !workflowData ||
        !workflowData.WorkflowCourses ||
        workflowData.WorkflowCourses.length == 0
      )
        return 0;

      let result = 0;
      workflowData.WorkflowCourses.forEach((element) => {
        result += element.Price;
      });
      return result;
    },
    __getCourseTotalDiscountPrice(workflowData = this.wfModel) {
      if (
        !workflowData ||
        !workflowData.WorkflowCourses ||
        workflowData.WorkflowCourses.length == 0
      )
        return 0;

      let result = 0;
      workflowData.WorkflowCourses.forEach((element) => {
        result += element.DiscountPrice;
      });
      return result;
    },
    __getSupplementVideoTotalPrice(workflowData = this.wfModel) {
      if (
        !workflowData ||
        !workflowData.WorkflowCourses ||
        workflowData.WorkflowCourses.length == 0
      )
        return 0;

      let result = 0;
      workflowData.WorkflowCourses.forEach((element) => {
        result += element.SupplementVideoPrice;
      });
      return result;
    },
    __getCourseTotalDecreaseAmount(workflowData = this.wfModel) {
      if (!workflowData || !workflowData.CourseDiscountTotalPrice) return 0;

      let courseTotalPrice = this.__getCourseTotalPrice();
      let courseDiscountTotalPrice = this.__getCourseTotalDiscountPrice();
      let value = courseTotalPrice - courseDiscountTotalPrice;
      // if (workflowData.WorkflowRelatedDicountAmount > 0){
      //   value -= workflowData.WorkflowRelatedDicountAmount;
      // }else{
      //   value += workflowData.WorkflowRelatedDicountAmount;
      // }

      // let value =
      //   toDecimal(this.excessAmount) +
      //   courseTotalPrice +
      //   workflowData.BalanceInStore -
      //   workflowData.AdvanceEnrollmentPrice -
      //   paymentTotal -
      //   this.accountModel.Debt -
      //   workflowData.BalanceCost -
      //   workflowData.BonusPointAmount -
      //   workflowData.CashDecreasedAmount -
      //   workflowData.CouponDiscountDollar;

      if (value < 0) {
        value = 0;
      }
      return value;
    },
    __getRefundBalanceTotal(workflowData = this.wfModel) {
      if (
        !workflowData ||
        !workflowData.RefundHistoryList ||
        workflowData.RefundHistoryList.length == 0
      )
        return 0;

      let result = 0;
      workflowData.RefundHistoryList.forEach((element) => {
        result += element.RefundBalance + element.RefundBalanceTax;
      });
      return result;
    },
    __getRefundBonusPointTotal(workflowData = this.wfModel) {
      if (
        !workflowData ||
        !workflowData.RefundHistoryList ||
        workflowData.RefundHistoryList.length == 0
      )
        return 0;

      let result = 0;
      workflowData.RefundHistoryList.forEach((element) => {
        result += element.RefundBonusPoint;
      });
      return result;
    },
    __getRefundBonusPointAmountTotal(workflowData = this.wfModel) {
      if (
        !workflowData ||
        !workflowData.RefundHistoryList ||
        workflowData.RefundHistoryList.length == 0
      )
        return 0;

      let result = 0;
      workflowData.RefundHistoryList.forEach((element) => {
        result += element.RefundBonusPointAmount;
      });
      return result;
    },
    __getRefundRelatedDicountAmountTotal(workflowData = this.wfModel) {
      if (
        !workflowData ||
        !workflowData.RefundHistoryList ||
        workflowData.RefundHistoryList.length == 0
      )
        return 0;

      let result = 0;
      workflowData.RefundHistoryList.forEach((element) => {
        result += element.RefundRelatedDicountAmount;
      });
      return result;
    },
    __getSaveModel() {
      let saveModel = $.extend(true, {}, this.accountModel);

      return saveModel;
    },
    __getPaidAmount(account = this.accountModel) {
      if (
        !account ||
        !account.AccountPayments ||
        account.AccountPayments.length == 0
      )
        return 0;

      let result = 0;
      for (let i = 0; i < account.AccountPayments.length; i++) {
        let payment = account.AccountPayments[i];
        if (!payment.Enable) continue;
        result += payment.Amount;
      }
      return result;
    },
    __getPaidAmountTax(account = this.accountModel) {
      if (
        !account ||
        !account.AccountPayments ||
        account.AccountPayments.length == 0
      )
        return 0;

      let result = 0;
      for (let i = 0; i < account.AccountPayments.length; i++) {
        let payment = account.AccountPayments[i];
        if (!payment.Enable) continue;
        result += payment.Tax;
      }
      return result;
    },
    __getPaidServiceCharge(account = this.accountModel) {
      if (
        !account ||
        !account.AccountPayments ||
        account.AccountPayments.length == 0
      )
        return 0;

      let result = 0;
      for (let i = 0; i < account.AccountPayments.length; i++) {
        let payment = account.AccountPayments[i];
        if (!payment.Enable) continue;
        result += payment.ServiceCharge;
      }
      return result;
    },
    onContractAgreed(workflowCourseId) {
      let workflowCourse = this.wfModel.WorkflowCourses.find(
        (item) => item.Id === workflowCourseId
      );
      if (!workflowCourse) return;

      workflowCourse.HasContractAgreed = true;
    },
    reloadDataForPaymentBillEditor(payment = null) {
      let newData = {
        id: 0,
        hasEMT: !!this.wfModel && !this.wfModel.IsCompleted,
        currency: 2,
        paymentAmount: 0,
        paymentTypeId: 0,
        paymentDate: new Date(),
        name: null,
        email: null,
        comment: null,
        imageFiles: [],
      };

      if (!!payment) {
        newData.id = payment.Id;
        newData.paymentAmount = toDecimal(payment.Amount + payment.Tax);
        newData.paymentTypeId = payment.PaymentTypeId;
        (newData.paymentDate = payment.Date), (newData.name = payment.Name);
        newData.email = payment.Email;
        newData.comment = payment.Comment;
        newData.imageFiles = payment.ImageFiles.map((item) => ({
          Id: item.Id,
          FileId: item.FileStorageId,
          FIleName: item.FileStorageName,
          Path: item.FileStoragePath,
        }));
      } else {
        newData.paymentAmount = toDecimal(this.accountModel.Debt);
        newData.paymentTypeId = !!this.wfModel ? this.wfModel.PaymentType : 0;
      }

      this.dataForComponents.paymentBillEditor = newData;
    },
    openPaymentBillEditor() {
      let paymentBillEditor =
        this.$vueRefStore.getChildrenRef("paymentBillEditor");
      if (!paymentBillEditor) return;

      paymentBillEditor.showDialog();
    },
    closePaymentBillEditor() {
      let paymentBillEditor =
        this.$vueRefStore.getChildrenRef("paymentBillEditor");
      if (!paymentBillEditor) return;

      paymentBillEditor.closeDialog();
    },
    onPaymentClick() {
      if (!this.workflowHasUnsignedContracts) {
        this.handlePayment();
      } else {
        this.contractDialogVisible = true;
      }
    },
    handlePayment() {
      this.reloadDataForPaymentBillEditor();
      this.openPaymentBillEditor();
    },
    onContractSigned() {
      this.contractDialogVisible = false;
      this.workflowHasUnsignedContracts = false;
      this.handlePayment();
    },
    onPaymentBillEditorCompleted(dataOut) {
      let product = `${this.dataModel.phone} 课程报名`; //`${phone} 课程报名：${strCourseNames}`;

      if (dataOut.paymentTypeId == this.GLOBAL.enumPaymentType.creditCard) {
        this.closePaymentBillEditor();

        this.reloadDataForStripeHandler(
          dataOut.paymentAmount,
          dataOut.serviceCharge,
          product,
          dataOut.comment
        );

        this.$nextTick(() => {
          this.openStripeHandler();
        });
        return;
      }

      if (dataOut.paymentTypeId !== this.GLOBAL.enumPaymentType.emt) {
        this.closePaymentBillEditor();

        let strCourseNames =
          this.dataForComponents.courseEnrollmentList.courseList.reduce(
            (prev, item) => `${prev}${item.courseName},`,
            String.empty
          );
        strCourseNames = strCourseNames.rTrim(",");

        this.reloadDataForQRCodeViewer(
          dataOut.paymentAmount,
          dataOut.serviceCharge,
          dataOut.paymentTypeId,
          product,
          dataOut.comment
        );

        this.$nextTick(() => {
          this.openQRCodeViewer();
        });
        return;
      }

      let saveData = this.__getSaveModel();
      let apEntity = saveData.AccountPayments.find(
        (item) => item.Id === dataOut.id
      );
      if (!apEntity) {
        let dateText = moment(new Date()).format("YYYY/MM/DD");
        let payment = {
          Id: dataOut.id,
          Enable: true,
          PaymentTypeDescription: getPaymentTypeDescription(
            dataOut.paymentTypeId
          ),
          PaymentTypeId: dataOut.paymentTypeId,
          Amount: this.accountModel.Amount,
          Tax: this.accountModel.AmountTax,
          ServiceCharge: dataOut.serviceCharge,
          DateText: dateText,
          Name: dataOut.name,
          Email: dataOut.email,
          Comment: dataOut.comment,
          ImageFiles: dataOut.imageFiles.map((item) => ({
            Id: 0,
            AccountPaymentId: 0,
            FileStorageId: item.FileId,
          })),
        };
        saveData.AccountPayments.push(payment);
      } else {
        apEntity.Name = dataOut.name;
        apEntity.Email = dataOut.email;
        apEntity.Comment = dataOut.comment;
        apEntity.ImageFiles = dataOut.imageFiles.map((item) => ({
          Id: item.Id,
          AccountPaymentId: dataOut.id,
          FileStorageId: item.FileId,
        }));
      }

      this.$nextTick(async () => {
        let result = await this.saveAccountDataToServer(saveData);
        this.$message({
          message: `保存${result ? "成功" : "失败"}`,
          type: result ? "success" : "error",
        });
        if (!!result) {
          this.loadAccountDataFromProps(saveData);
          await this.reloadDataModel();
          this.reloadDataForAccountInfo();

          this.closePaymentBillEditor();
          this.isLoading = true;
          saveWorkflowStatus(this.wfModel.Id, 2).then((result) => {
            if (result.success) {
              this.isCompleted = true;
              this.status = 2;
              this.init();
              this.dataChanged = true;
            } else {
              if (result.message) {
                this.$message.error(result.message);
              }
              this.isLoading = false;
            }
          });
        }
      });
    },
    reloadDataForQRCodeViewer(
      paymentAmount,
      tipAmount,
      paymentType,
      product,
      description
    ) {
      let newData = {
        workflowId: 0,
        autonomousPaymentRecordId: null,
        paymentAmount: 0,
        tipAmount: 0,
        paymentType: null,
        product: null,
        description: null,
      };

      newData.workflowId = !!this.wfModel ? this.wfModel.Id : 0;
      newData.autonomousPaymentRecordId = !!this.wfModel
        ? this.wfModel.CurrentAutonomousPaymentRecordId
        : null;
      newData.paymentAmount = paymentAmount;
      newData.tipAmount = tipAmount;
      newData.paymentType = paymentType;
      newData.product = product;
      newData.description = description;

      this.dataForComponents.qrCodeViewer = newData;
    },
    openQRCodeViewer() {
      let qrCodeViewer = this.$vueRefStore.getChildrenRef("qrCodeViewer");
      if (!qrCodeViewer) return;

      qrCodeViewer.showDialog();
    },
    closeQRCodeViewer() {
      let qrCodeViewer = this.$vueRefStore.getChildrenRef("qrCodeViewer");
      if (!qrCodeViewer) return;

      qrCodeViewer.closeDialog();
      this.isCompleted = true;
      this.init();
      this.dataChanged = true;
    },
    onQRCodeViewerSuccess(paymentRequestId) {
      setTimeout(() => {
        this.closeQRCodeViewer();
      }, 5000);
    },
    reloadDataForStripeHandler(paymentAmount, tipAmount, product, description) {
      let newData = {
        workflowId: 0,
        autonomousPaymentRecordId: null,
        paymentAmount: 0,
        tipAmount: 0,
        product: null,
        description: null,
      };

      newData.workflowId = !!this.wfModel ? this.wfModel.Id : 0;
      newData.autonomousPaymentRecordId = !!this.wfModel
        ? this.wfModel.CurrentAutonomousPaymentRecordId
        : null;
      newData.paymentAmount = paymentAmount;
      newData.tipAmount = tipAmount;
      newData.product = product;
      newData.description = description;

      this.dataForComponents.stripeHandler = newData;
    },
    openStripeHandler() {
      let stripeHandler = this.$vueRefStore.getChildrenRef("stripeHandler");
      if (!stripeHandler) return;

      stripeHandler.showDialog();
    },
    getStatusClass(status) {
      return getWorkflowStatusClass(status);
    },
    getStatusText(value) {
      let item = this.allStatusList.find((i) => i.key == value);
      return item.value;
    },
    handleStatusChange(value) {
      let statusText = this.getStatusText(value);
      this.$confirm("您确认要修改支付状态为" + statusText + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isLoading = true;
          saveWorkflowStatus(this.wfModel.Id, value).then((result) => {
            if (result.success) {
              this.status = value;
              this.loadStatusList();
              this.dataChanged = true;
            } else {
              if (result.message) {
                this.$message.error(result.message);
              }
            }
            this.isLoading = false;
          });
        })
        .catch(() => {});
    },
    onCheckPaymentClick() {
      this.$nextTick(async () => {
        this.isPaymentChecking = true;
        await this.refreshEFWorkflowStatusFromServer();
        this.isPaymentChecking = false;
        this.init();
      });
    },
    openPaymentCommentEditor(data) {
      this.dataForComponents.paymentCommentEditor = {
        accountPaymentId: data.Id,
        comment: data.Comment,
      };

      this.paymentCommentEditorVisible = true;
    },
    async onPaymentCommentEditorSuccess(data) {
      this.$message({
        message: `保存备注成功`,
        type: "success",
      });

      let payment = this.accountModel.AccountPayments.find(
        (i) => i.Id === data.accountPaymentId
      );
      payment.Comment = data.comment;
      this.dataModel.accountPayments = $.extend(
        true,
        [],
        this.accountModel.AccountPayments
      );
      this.paymentCommentEditorVisible = false;
      this.dataChanged = true;
    },

    openAccountCommentEditor() {
      this.dataForComponents.accountCommentEditor = {
        accountId: this.accountModel.Id,
        comment: this.accountModel.Comment,
      };

      this.accountCommentEditorVisible = true;
    },
    async onAccountCommentEditorSuccess(data) {
      this.$message({
        message: `保存账目备注成功`,
        type: "success",
      });
      this.accountModel.Comment = data.comment;
      this.accountCommentEditorVisible = false;
      this.dataChanged = true;
    },
    onEidtAccountCommentClick() {
      this.openAccountCommentEditor();
    },
    onViewBillDetail(){
      this.reloadDataForBillDetail();
      this.billDetailDialogVisible = true;
    },
    reloadDataForBillDetail() {
      let newData = {
        discountNames: "",
        courseList: [],
        courseOriginalPrice: 0,
        courseTotalDiscountPrice: 0,
        courseTotalDecreaseAmount: 0,
        workflowRelatedDicountAmount: 0,
        balance: 0,
        bonusPointAmount: 0,
        enrollmentCountAmount: 0,
        accountDiscountAmount: 0,
        taxModel: {
          hasTax: false,
          taxRate: 0.13,
          courseTotalTax: 0
        },
        accountAmount: 0
      };
      console.log(this.dataModel);
      if (!!this.dataModel.discountNameArr && !!this.dataModel.discountNameArr.length > 0) {
        newData.discountNames = this.dataModel.discountNameArr.join(",");
      }
      
      if (!!this.dataForComponents.courseEnrollmentList && !!this.dataForComponents.courseEnrollmentList.courseList) {
        newData.courseList = this.dataForComponents.courseEnrollmentList.courseList;
      }

      newData.courseOriginalPrice = this.dataModel.courseTotalPrice || 0;
      newData.courseTotalDiscountPrice = this.dataModel.courseTotalDiscountPrice || 0;
      newData.courseTotalDecreaseAmount = this.dataModel.courseTotalDecreaseAmount || 0;
      newData.workflowRelatedDicountAmount = this.dataModel.workflowRelatedDicountAmount || 0;
      newData.balance = this.newBalanceCostTotal + this.giftBalanceCostTotal + this.oldBalanceCostTotal;
      newData.bonusPointAmount = this.dataModel.bonusPointAmount || 0;
      newData.enrollmentCountAmount = (this.dataModel.advanceEnrollmentPrice || 0) + (this.dataModel.advanceEnrollmentPriceTax || 0);
      newData.cashDecreasedAmount = (this.dataModel.cashDecreasedAmount || 0);
      
      if (!!this.wfModel) {
        newData.taxModel.hasTax = this.wfModel.HasTax || false;
        newData.taxModel.taxRate = this.wfModel.TaxRate || 0;
      }
      newData.taxModel.courseTotalTax = this.dataModel.totalTax || 0;
      
      newData.accountAmount = this.accountModel ? (this.accountModel.Amount || 0) : 0;
  
      this.dataForComponents.billDetail = newData;
    },
  },
  watch: {
    data: function (newVal) {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/finance/cefAccountProfile.vue